import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useThemeMode} from '../../../../_metronic/partials'
import {ToolTipUIForModal} from '../../widgets/components/UI/ToolTipUIForModal'
import {useAuth} from '../../auth'
import {accessPortalForQuotaUpgrade} from '../core/_requests'
// import { useCurrency } from '../../../hooks/useCurrency'
// import { getCurrencySymbol } from '../../../core/_util'
import {toast} from 'react-toastify'
type AddOnObject = {
  [key: string]: number
}
type ResultObject = {
  redirectUrl: string
  currency: string
  duration: string
  planName: string
  recurringAddOn?: AddOnObject
  nonRecurringAddOn?: AddOnObject
  couponCodes?: string[]
}
const PurchaseModal = ({isModalActive, setIsModalActive, item, props}: any) => {
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  const [loading, setLoading] = useState(false)
  const [isCouponApplied, setIsCouponApplied] = useState(false)
  const [couponCode, setCouponCode] = useState('')
  const [quantity, setQuantity] = useState(1)
  const {companyId, currencyBill, currentState, companyCurrency, billingData} = useAuth() //eslint-disable-line
  // const { currencyOptions } = useCurrency()
  const [urlData, setUrlData] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [showCouponInput, setShowCouponInput] = useState(false)

  useEffect(() => {
    if (item?.recurringType === 'recurring') {
      setQuantity(item?.purchasedQuantity)
    }
  }, [item])

  const handleIncrement = () => {
    setQuantity(quantity + 1)
  }

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  const totalPrice = quantity * item?.price
  const discount = couponCode.toLowerCase() === 'foundercrate' ? totalPrice * 0.2 : 0

  const payableAmount = totalPrice - discount

  const transformObject = (item: any) => {
    const planName =
      billingData.subscription_items.find((item: any) => item.item_type === 'plan')
        ?.item_price_id || null

    const result: ResultObject = {
      redirectUrl: window.location.href,
      currency: currencyBill,
      duration: currentState,
      planName,
    }

    const trimmedCoupon = couponCode.trim()
    if (trimmedCoupon) {
      result.couponCodes = [trimmedCoupon]
    }

    if (item.recurringType === 'recurring') {
      result.recurringAddOn = {
        [item.key]: quantity,
      }
    } else if (item.recurringType === 'non-recurring') {
      result.nonRecurringAddOn = {
        [item.key]: quantity,
      }
    }

    return result
  }

  const getPortalLink = async () => {
    try {
      setLoading(true)
      const {
        data: {data, success, errors},
      } = await accessPortalForQuotaUpgrade(companyId!, transformObject(item))
      if (success) {
        setUrlData(data)
        setShowModal(true)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
      setIsModalActive(false)
    }
  }

  return (
    <div>
      <Modal
        {...props}
        show={isModalActive}
        onHide={() => {
          setIsModalActive(false)
        }}
        size='md'
      >
        <Modal.Header closeButton>
          <div className='d-flex flex-column'>
            <h2>{formatMessage({id: `Purchase More ${item?.title}`})}</h2>
          </div>
        </Modal.Header>
        <Modal.Body className='container'>
          <div className='row' style={{height: '200px'}}>
            <div className='col-md-7 col-12 d-flex flex-column'>
              <p className='font-size-16 mb-0 fw-semibold d-flex align-items-center'>
                {formatMessage({id: `${item?.title}`})}
                <ToolTipUIForModal
                  tooltipText={formatMessage({
                    id: `Select the additional ${item?.title} you want to purchase.`,
                  })}
                />
              </p>
              <p className='text-muted font-size-12 fw-medium mb-0'>
                {billingData?.company_country?.currency === 'INR' ? '$' : '$'}
                {formatMessage({id: `${item?.price} per ${item?.type}`})}
              </p>
            </div>
            <div className='col-md-3 col-5'>
              <div className='d-flex justify-content-between align-items-center gap-4 bg-light border rounded p-2'>
                <div>
                  <button
                    type='button'
                    className={`btn custom-button-property 
                      ${
                        (quantity === 0 && item?.recurringType === 'recurring') ||
                        (quantity === 1 && item?.recurringType === 'non-recurring')
                          ? 'bg-secondary text-muted'
                          : 'bg-primary text-white'
                      } 
                      px-2 py-0 font-size-16`}
                    disabled={
                      (quantity === 0 && item?.recurringType === 'recurring') ||
                      (quantity === 1 && item?.recurringType === 'non-recurring')
                    }
                    onClick={handleDecrement}
                  >
                    -
                  </button>
                </div>
                <p className='m-0 font-size-16 mb-0'>{quantity}</p>
                <div>
                  <button
                    type='button'
                    className='btn bg-primary custom-button-property text-white px-2 py-0 font-size-16'
                    onClick={handleIncrement}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
            <div className='col-md-2 col-7 d-flex  justify-content-md-between justify-content-end gap-md-0 gap-2 mt-md-2 mt-2'>
              <p className='col-md-6 d-flex justify-content-start font-size-16 mb-0 fw-semibold'>
                {formatMessage({id: '='})}
              </p>
              <p className='col-md-6 d-flex justify-content-end font-size-16 mb-0 fw-semibold'>
                {' '}
                {billingData?.company_country?.currency === 'INR' ? '$' : '$'}
                {totalPrice}
              </p>
            </div>
          </div>
          <div className=''>
            <div className='row'>
              <div className='d-flex flex-column col-lg-12 col-12'>
                {/* Total Amount  */}
                <div className='d-flex align-items-center justify-content-between'>
                  <p className='d-flex justify-content-md-end justify-content-start'>
                    {formatMessage({id: 'Total'})}
                  </p>
                  <p className='col-lg-3 col-6 d-flex justify-content-end font-size-16 fw-bold'>
                    {' '}
                    {billingData?.company_country?.currency === 'INR' ? '$' : '$'}
                    {totalPrice}
                  </p>
                </div>

                <div className='d-flex justify-content-end'>
                  <div className='col-lg-12 col-12 border mb-4'></div>
                </div>

                {/* Discounted Amount  */}
                <div className='d-flex align-items-center justify-content-between'>
                  <div>
                    <p className='mb-2'>{formatMessage({id: 'Promotional Discount'})}</p>

                    <div>
                      {!showCouponInput ? (
                        <label
                          onClick={() => setShowCouponInput(true)}
                          className='mb-4 cursor-pointer d-flex align-items-center gap-1'
                        >
                          <p className='text-primary mb-0'>
                            {formatMessage({id: 'Have a coupon code?'})}{' '}
                          </p>

                          <ToolTipUIForModal
                            tooltipText={formatMessage({
                              id: 'Enter promotional code to avail special discounts',
                            })}
                          />
                        </label>
                      ) : (
                        <div className='d-flex'>
                          {!isCouponApplied ? (
                            <>
                              <div className='border bg-white rounded d-md-flex justify-content-between align-items-center p-1 mb-4'>
                                <div className='d-flex flex-grow-1'>
                                  <input
                                    type='text'
                                    value={couponCode}
                                    onChange={(e) => setCouponCode(e.target.value)}
                                    placeholder={formatMessage({id: 'Coupon Code'})}
                                    className='form-control w-100 border border-0 font-size-12 fw-light'
                                    style={
                                      mode === 'dark'
                                        ? {background: '#323248'}
                                        : {background: '#ffffff'}
                                    }
                                  />
                                </div>
                                <button
                                  className='btn bg-primary text-white custom-button-property mt-2 mt-md-0 w-100 w-md-auto font-size-13'
                                  onClick={() => {
                                    setIsCouponApplied(true)
                                  }}
                                >
                                  {formatMessage({id: 'Apply'})}
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className='d-flex align-items-center gap-2 mb-4'>
                                <p className='mb-0 text-primary font-size-14 text-uppercase'>
                                  {couponCode}
                                </p>
                                <button
                                  className='btn px-2 py-0'
                                  style={{background: '#4776E61A', borderRadius: '4px'}}
                                  onClick={() => {
                                    setIsCouponApplied(false)
                                    setCouponCode('')
                                  }}
                                >
                                  <i className='fa-solid fa-xmark text-primary p-0'></i>
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <p className='col-lg-3 col-6 d-flex justify-content-end font-size-16 fw-bold'>{`- ${
                    billingData?.company_country?.currency === 'INR' ? '$' : '$'
                  }${discount.toFixed(2)}`}</p>
                </div>

                <div className='d-flex justify-content-end'>
                  <div className='col-lg-12 col-12 border mb-4'></div>
                </div>

                {/* Payable Amount  */}
                <div className='d-flex align-items-center justify-content-between'>
                  <p className='d-flex justify-content-md-end justify-content-start'>
                    {formatMessage({id: 'Payable Amount Now'})}
                  </p>
                  <p className='col-lg-3 col-6 d-flex justify-content-end font-size-24 fw-bold'>
                    {billingData?.company_country?.currency === 'INR' ? '$' : '$'}
                    {payableAmount.toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-md-flex w-100 w-md-auto justify-content-end px-0 gap-3'>
            <div className='w-100 order-1 order-md-2 mb-2 mb-md-auto'>
              <button
                type='submit'
                className='btn bg-primary text-white custom-button-property w-100'
                onClick={getPortalLink}
              >
                {loading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {formatMessage({id: 'Please wait'})}...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  <span className='indicator-label'>{formatMessage({id: 'Update'})}</span>
                )}
              </button>
            </div>
            <div className='w-100 w-md-auto order-2 order-md-1'>
              <button
                type='button'
                className='btn bg-light text-muted custom-button-property w-100'
                onClick={() => setIsModalActive(!isModalActive)}
              >
                {formatMessage({id: 'Cancel'})}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        backdropClassName='sub-modal-2'
        className='sub-modal-2'
      >
        <Modal.Body>
          <iframe title='Add Credits' src={urlData} width='100%' height={600}></iframe>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default PurchaseModal
